export default [
  {
    name: `video_intro`,
    exitButton: `동영상 건너뛰기`,
  },
];
